import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import Bonuses from "shared/ui/Bonuses";
import Button from "shared/ui/Button";
import ImageLazy from "shared/ui/ImageLazy";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import { fetchUserInfo } from "shared/redux/asyncActions/fetchUserInfo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IGift } from "pages/Gift/api/models";
import { GetTransactionBonusApi } from "./api";
import { IMyGift } from "./api/models";
import QRCode from "react-qr-code";
import Activate from "widgets/Gift/AuthContent/Activate";

const MyGiftContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { user_info, auth_key } = useAppSelector(userSelect);

  const [gift, setGift] = useState<IMyGift>();

  const dateOptions: any = {
    minute: "2-digit",
    hour: "2-digit",
    month: "long",
    day: "2-digit",
  };

  const callbackSuccessAction = (tr_id: number, active: boolean) => {
    if (user_info && auth_key) {
      dispatch(fetchUserInfo({ auth_key, user_id: user_info.id }));
      fetchGiftInfo();
      dispatch(setOpen(false));

      if (pathname === `/gift/${id}` && active) {
        navigate(`/account/gift/${tr_id}`);
      }
    }
  };

  const handleActivate = () => {
    if (gift) {
      dispatch(setOpen(true));
      dispatch(
        setContent(
          <Activate
            id={gift.bonus_id}
            onSuccess={callbackSuccessAction}
            price={gift.price}
            text={
              "Запросите код приза у сотрудника магазина, инфостойки или ресторана"
            }
          />
        )
      );
    }
  };

  const fetchGiftInfo = () => {
    if (auth_key && user_info && id) {
      GetTransactionBonusApi({
        auth_key,
        id: Number(id),
        user_id: user_info.id,
      }).then((res) => setGift(res));
    }
  };

  useEffect(() => {
    fetchGiftInfo();
  }, [auth_key, user_info, id]);

  return (
    <section className={s.content}>
      <section className={s.content}>
        <div className={s.top}>
          {gift?.tr_activated === 1 && (
            <div className={s.transaction}>
              <span className={s.number}>Номер транзакции</span>
              <h4>{gift.tr_num}</h4>

              <div className={s.time}>
                {new Date(gift.activated_time).toLocaleString([], dateOptions)}
              </div>
              <div className={s.time}>
                <span>Текущее время:</span>{" "}
                {new Date().toLocaleString([], dateOptions)}
              </div>
            </div>
          )}

          <GoBack className={s.go_back} />

          <div className={s.image}>
            {gift && <ImageLazy src={gift.image} alt="Gift" />}
          </div>

          <div className={s.data}>
            <h1>{gift?.title}</h1>

            <div className={s.row}>
              <div className={s.group}>
                {/* <span className={s.shop}>{gift?.place_title}</span> */}

                {gift && (
                  <span className={s.date}>
                    {new Date(gift.period_to).toLocaleDateString()}
                  </span>
                )}
              </div>

              {gift && <Bonuses count={gift.price} />}
            </div>
          </div>
        </div>

        <div className={s.block}>
          {gift?.tr_activated === 1 && (
            <div className={s.code}>

              <QRCode value={gift.tr_num} />

              <p>{gift.tr_num}</p>
            </div>
          )}

          {!gift ? (
            <div className={s.data}></div>
          ) : (
            <div
              className={s.data}
              dangerouslySetInnerHTML={{ __html: gift?.text }}
            ></div>
          )}

          {gift?.mes_to_act && (
            <div className={`${s.payment} ${s.center}`}>{gift?.mes_to_act}</div>
          )}

          {gift?.tr_activated !== 1 && (
            <div className={s.payment}>
              <Button onClick={handleActivate}>Активировать</Button>
            </div>
          )}
        </div>
      </section>
    </section>
  );
};

export default MyGiftContent;
